import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type"];
import React, { useContext } from 'react';
import { MainContext } from '@blaze-cms/nextjs-components';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import PropTypes from 'prop-types';
import flatten from 'lodash.flatten';
import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { buildUserQuery, buildPropsData } from './helpers';
import { getSingleEntitySchema, getUser } from '../../application/query';
import BannerRender from './BannerRender';
import buildPropsQuery from '../../helpers/build-props-query';
import { getClassModifiers } from '../../utils';
import getEntityRenderProps from '../../helpers/get-entity-render-props';
const Banner = _ref => {
  let {
      type
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const router = useRouter();
  const {
    isPreview
  } = useContext(MainContext);
  const {
    id: userId
  } = checkIfLoggedIn();
  const {
    asPath
  } = router;
  const {
    parent,
    entity,
    sizeId,
    propsToDisplay = [],
    userPropsToDisplay = []
  } = otherProps;
  const userQuery = buildUserQuery(userPropsToDisplay);
  const {
    itemEntity
  } = parent;
  const {
    data,
    error,
    loading
  } = useQuery(getSingleEntitySchema, {
    variables: {
      id: entity || itemEntity
    }
  });
  const {
    data: {
      getUser: userData
    } = {},
    loading: userLoading
  } = useQuery(getUser(userQuery), {
    variables: {
      id: userId
    },
    skip: !userPropsToDisplay.length || !userId
  });
  if (loading || userLoading) return '';
  if (error) return error.message;
  if (!data) return null;
  if (!sizeId) return null;
  const modifiers = getClassModifiers('banner', otherProps);
  const queryProps = buildPropsQuery(data, propsToDisplay.length ? flatten(propsToDisplay.map(({
    propertiesToDisplay
  }) => propertiesToDisplay)) : []);
  const userPropsData = buildPropsData(userData, userPropsToDisplay);
  const {
    actionKey,
    action
  } = getEntityRenderProps(queryProps, data, isPreview);
  const bannerKey = `${sizeId}${asPath}`;
  return /*#__PURE__*/React.createElement(BannerRender, _extends({
    key: bannerKey
  }, otherProps, {
    action: action,
    actionKey: actionKey,
    asPath: asPath,
    userPropsData: userPropsData,
    modifiers: modifiers
  }));
};
Banner.propTypes = {
  type: PropTypes.string
};
Banner.defaultProps = {
  type: 'banner'
};
export default Banner;
//# sourceMappingURL=Banner.js.map